"use strict";
var AnimationFrameAction_1 = require("./AnimationFrameAction");
var AnimationFrameScheduler_1 = require("./AnimationFrameScheduler");
exports.animationFrame = new AnimationFrameScheduler_1.AnimationFrameScheduler(AnimationFrameAction_1.AnimationFrameAction);
//# sourceMappingURL=animationFrame.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/scheduler/animationFrame.js
 ** module id = 455
 ** module chunks = 1
 **/